<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page pl-5 pr-5 mt-4" v-else-if="loaded" >
        
        <div class="col-11 offset-1 text-right position-absolute top-0 mt-3 mr-4 right-0" >
            <button class="btn btn-primary btn-sm" @click="configureTracking(  )" id="tooltip-configure-all-ads"  > Set up ads </button>            
            <b-tooltip target="tooltip-configure-all-ads" placement="bottom" triggers="hover"  >
                This action will configure the URL parameters ( URL tags field ) of the ads for tracking, <br> by adding the following code: <br>  <code v-pre > fbadid={{ad.id}}&fbadname={{ad.name}} </code> 
            </b-tooltip>
        </div>
        
        <div class="row" >
            <div class="col-12" >
                <b-input-group>
                    <b-form-input v-model="filter" placeholder="Search by email, name or phone" class="search-input atlass-input-borderless" />
                    <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
                </b-input-group>
            </div>
        </div>
        
        <vue-good-table
            class=""
            :columns="columnns"
            :rows="data"
            styleClass="vgt-table atlass-datatable mt-4 firstTdBold font-size-12"
            :search-options="{ enabled: true, externalQuery: filter }"
            :pagination-options="{ 
                enabled: true,
                perPage: 20,
                perPageDropdown: [50, 100],
                ropdownAllowAll: true,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Leads per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
            }"
            :selectOptions="{
                enabled: false,
                selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
              }"
             >
            
                <template slot="table-row" slot-scope="props">
                    
                    <span v-if="props.column.field == 'name'">
                        <b> {{props.row.name}} </b> 
                        <a :href="`${props.row.preview_shareable_link}`" v-if="props.row.preview_shareable_link != ''" target="_blank" title="See ad preview" > <font-awesome-icon :icon="['fa', 'external-link-alt']" class="graymedium-color" /> </a>
                    </span>
                    
                    <span v-else-if="props.column.field == 'effective_status'">
                        <b-badge v-if="props.row.effective_status == 'ACTIVE'" variant="success">ACTIVE</b-badge>
                        <b-badge v-else-if="props.row.effective_status != 'ACTIVE'" variant="secondary"> {{ props.row.status }} </b-badge>
                    </span>
                    
                    <span v-else-if="props.column.field == 'actions'">
                        <button class="btn btn-primary btn-sm" @click="configureTracking(props.row)" > Set up </button>
                    </span>
                    
                </template>
            
        </vue-good-table>
        
        <modal :modalData="modalData" :modalState="modalState" modalComponent="lead" ></modal>
        
    </div> <!-- .page -->

</template>

<script>
//import modal from '@/components/modal.vue'    

import firebase from "firebase";
import Cookies from 'js-cookie'
import moment from 'moment'  
import axios from 'axios'
import helper from '@/helpers/helpers.js';
    
export default {
    name: 'orders',
    components:{
        modal: () => import('@/components/modal.vue')
    },
    props: {
        data: { 
            type: [Array],
        }
    },
    data: function(){
        return {
            filter: '',
            loaded: false,
            modalState : false,
            modalData: null,
            title: false,
            columnns:[
                {
                    label: 'AD',
                    field: 'name',
                    //field: this.returnName,
                },
                {
                    label: 'AD SET',
                    field: 'adset.name',
                    //field: this.returnName,
                },
                {
                    label: 'CAMPAIGN',
                    field: 'campaign.name',
                    //field: this.returnName,
                },
                /*
                {
                    label: 'ACCOUNT',
                    field: 'account_id',
                    //field: this.returnName,
                },
                */
                {
                    label: 'URL LINK',
                    field: 'creative',
                    formatFn: this.return_link,
                    //field: this.returnName,
                },
                
                {
                    label: 'URL TAGS',
                    field: 'creative.url_tags',
                    //field: this.returnName,
                },
                
                {
                    label: 'STATUS',
                    field: 'status',
                    //type: 'number',
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
                /*
                {
                    label: 'ACTIONS',
                    field: 'actions',
                    sortable: false,
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
                {
                    label: 'CREATED',
                    field: this.returnDate,
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
                */
            ],
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        //console.log("Tags component")
        //console.log(this.data)
        this.title = this.data[0].account_id;
        this.loaded = true;
    },
    beforeDestroy() {
    },
    methods: {
        returnDate(a){
            return this.$moment.unix(a.datetime).format( 'MMM D, HH:mm:ss' )
        },
        return_link(creative){
            //console.log(creative)
            let link = ''
            if( creative.object_story_spec ){
                if( creative.object_story_spec.link_data ){
                    link = creative.object_story_spec.link_data.link
                }else if( creative.object_story_spec.video_data ){
                    if( creative.object_story_spec.video_data.call_to_action ){
                        link = creative.object_story_spec.video_data.call_to_action.value.link
                    }
                    
                }else if( creative.object_story_spec.template_data ){
                    if( creative.object_story_spec.template_data.call_to_action ){
                        if( creative.object_story_spec.template_data.call_to_action.value && creative.object_story_spec.template_data.call_to_action.value.link ){
                            link = creative.object_story_spec.template_data.call_to_action.value.link
                        }
                    }
                    
                }
            }
                
            return link
            
        },
        
        configureTracking( ad = null ){
            
            if( ad == null ){
                console.log("Configure all ads")
            }else{
                console.log("Configure ad: ")
                console.log( ad )
            }
            
            let params = Cookies.get('user-token')
            let data = { "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ), "ad": ad }
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8', "X-Auth": params }
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/integrations/facebook/config-ads', headers: headers, data: data })
                .then(resp => {
                                
                if( resp.status == 200 ){
                    let r = resp.data;
                                        
                    console.log(r)
                    
                }
                
            }).catch(error => {
                console.log(error)
                
                this.$toast.error({
                    title:'Error',
                    message: error
                })
                
            }); //end axios 
            
        }
    },
    computed: {
        matches() {
            return this.filter
                ? this.data.filter(row => {
                  let match = false
                  for (let key in row) {
                    //console.log(campaign['name']);
                    if (row['name'].toLowerCase().includes(this.filter.toLowerCase())) {
                      return true
                    }
                  }
                })
                : this.data
        }
    },
    watch: {
        ID: function(){
            if( typeof this.ID == 'string' ){
                this.docID = this.ID
            }else{
                this.data = this.ID
            }
    
            //this.$refs.tags.$el.click()
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >


    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
</style>



// WEBPACK FOOTER //
// src/components/ads.vue